import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';

@Component({
  selector: 'phar-confirm',
  templateUrl: './confirm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmDialogModule, NgTemplateOutlet],
  standalone: true,
})
export class ConfirmComponent {
  key = input<'warning' | 'confirmation'>('warning');
}
